import { BarChart3, Clock, Users } from 'lucide-react';
import type { AdminStats } from '../hooks/useAdminStats';

function formatVolume(n: number): string {
  return n.toLocaleString('en-US', { maximumFractionDigits: 0 });
}

type StatsGridProps = {
  stats: AdminStats | null;
  loading: boolean;
};

export function StatsGrid({ stats, loading }: StatsGridProps) {
  const totalVolume = stats?.totalVolume ?? 0;
  const active = stats?.activeMerchants ?? 0;
  const total = stats?.totalMerchants ?? 0;
  const pendingCount = stats?.pendingMerchants ?? 0;

  return (
    <div className="admin-grid">
      <div className="admin-stat">
        <div className="admin-stat-icon" style={{ background: 'var(--onyx-gold-dim)' }}>
          <BarChart3 size={18} color="var(--onyx-gold)" aria-hidden />
        </div>
        <div className="stat-label">Total Volume (TVL)</div>
        <div style={{ fontSize: 26, fontWeight: 400, color: 'var(--onyx-gold)' }}>
          {loading ? '…' : formatVolume(totalVolume)}
        </div>
        <div style={{ fontSize: 11, color: 'var(--onyx-muted)', marginTop: 4 }}>USDT · from transactions</div>
      </div>
      <div className="admin-stat">
        <div className="admin-stat-icon" style={{ background: 'var(--onyx-blue-dim)' }}>
          <Users size={18} color="var(--onyx-blue)" aria-hidden />
        </div>
        <div className="stat-label">Active Merchants</div>
        <div style={{ fontSize: 26, fontWeight: 400, color: 'var(--onyx-blue)' }}>
          {loading ? '…' : active}
        </div>
        <div style={{ fontSize: 11, color: 'var(--onyx-muted)', marginTop: 4 }}>
          of {loading ? '…' : total} registered
        </div>
      </div>
      <div className="admin-stat">
        <div className="admin-stat-icon" style={{ background: 'rgba(245, 158, 11, 0.12)' }}>
          <Clock size={18} color="var(--onyx-amber)" aria-hidden />
        </div>
        <div className="stat-label">Pending Payouts</div>
        <div style={{ fontSize: 26, fontWeight: 400, color: 'var(--onyx-amber)' }}>
          {loading ? '…' : pendingCount}
        </div>
        <div style={{ fontSize: 11, color: 'var(--onyx-muted)', marginTop: 4 }}>
          merchants · pending review
        </div>
      </div>
    </div>
  );
}
